import React, { useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { premiacaoConsolidadoFilterConfig } from '../config/premiacaoConsolidadoFilterConfig';
import { getPremiacaoConsolidadoColumns } from '../config/premiacaoConsolidadoColumns';
import { usePremiacaoConsolidadoConsulta } from '../hooks/usePremiacaoConsolidadoConsulta';
import { usePremiacaoConsolidadoFiltrosOpcoes } from '../hooks/usePremiacaoConsolidadoFiltrosOpcoes';
import { applyOptionsToFilters } from '../utils/premiacaoMultiSelectFilters';

const PremiacaoConsolidadoModal = ({ show, onHide }) => {
  const {
    rows,
    loading,
    totalRegistros,
    consultaRealizada,
    handleFiltrosChange,
    resetConsulta,
    filtros
  } = usePremiacaoConsolidadoConsulta();

  const {
    nomeTabelaOpcoes,
    segmentoOpcoes,
    loadingOpcoes
  } = usePremiacaoConsolidadoFiltrosOpcoes(show);

  useEffect(() => {
    if (!show) {
      resetConsulta();
    }
  }, [show, resetConsulta]);

  const filterConfig = useMemo(
    () => applyOptionsToFilters(premiacaoConsolidadoFilterConfig, {
      nomeTabelaPremiacao: nomeTabelaOpcoes,
      segmentoTabelaPremiacao: segmentoOpcoes
    }),
    [nomeTabelaOpcoes, segmentoOpcoes]
  );

  const columns = getPremiacaoConsolidadoColumns();

  return (
    <Modal show={show} onHide={onHide} animation={false} size="xl" dialogClassName="modal-uniform-xl">
      <Modal.Header closeButton>
        <Modal.Title>Premiação Consolidada</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FilterPanel
          filters={filterConfig}
          values={filtros}
          onApply={handleFiltrosChange}
          title="Filtros de Consulta"
          loading={loading || loadingOpcoes}
          defaultCollapsed={false}
        />

        <div className="text-muted small mt-2 mb-2">
          {consultaRealizada
            ? `${totalRegistros} registro(s) após filtros de coluna`
            : 'Informe mês e ano de fechamento (período de 21 a 20) e clique em aplicar para consultar.'}
        </div>

        <TanStackTable
          columns={columns}
          data={rows}
          loading={loading}
          withPagination={true}
          pageSizeOptions={[10, 25, 50, 100, 1000]}
          initialState={{ pageSize: 1000 }}
          enableRowColors={true}
          className="mt-2"
          manualPagination={false}
          enableExportExcel={consultaRealizada && rows.length > 0}
          exportFileName="premiacao-consolidada"
        />
      </Modal.Body>
    </Modal>
  );
};

export default PremiacaoConsolidadoModal;
